import React from 'react';
import {isMobile} from "../commonmethod/CommonMethod";

function TabBasic({args, setArgs, className}) {

    const openListener = (idx) => {
        const arr = [];
        args.forEach((e, tdx) => {
            if (idx === tdx) {
                e.clicked = true
                arr.push(e)
            } else {
                e.clicked = false;
                arr.push(e)
            }
        });
        setArgs(arr)
    }

    return (
        <div className={`className ${isMobile? 'mobile-tab ':'tab-group'}`}>
            {args.map((each, idx) => (
                <div
                    key={idx}
                    className={`tab ${each.clicked ? 'tab-item-selected' : ''}`}
                    onClick={() => openListener(idx)}
                >
                    {each.name}
                </div>
            ))}
        </div>
    );
}

export default TabBasic;